export default {
  fontSize: {
    small: '.875rem',
    regular: '1rem'
  },
  fontFamily: "'acumin-pro-wide', 'Source Sans Pro', sans-serif"
}
